
import StateNavigation from './zviz2/zviz/navigation/state';
import HTMLRenderer from './zviz2/zviz/renderers/html';
import Main from './components/index';
import GA from './components/ga';
import SimpleEvent from './zviz2/zviz/event';
import state from './zviz2/zviz/state';
import UrlHash from './model/urlhash';
import global from './zviz2/zviz/global';
import {AnalyticsGoogle} from './helpers/analytics/google.js';
import {Analytics} from './helpers/analytics/index.js';

let setRenderSize = function(){
    let w = window.innerWidth || 1200;
    let curSize = state.get('renderSize');
    let size = 'large';
    if(w < 650){
        size = 'small';
    }else if(w < 1000){
        size = 'medium';
    }
    if(size != curSize){
        state.set('renderSize', size);
    }
    state.forceGlobalUpdate = true;
}
let windowResizeTimerId = null;
let windowResize = new SimpleEvent(window, 'resize', function(event){
    clearTimeout(windowResizeTimerId);
    windowResizeTimerId = setTimeout(setRenderSize, 1000);
});
setRenderSize();


// let nav = new HashNavigation(new Map([
//         ['source', 'eval'],
//         ['view', 'regional'],
//         // ['filter', null]
//     ]));//, ['filter']);


let nav = new StateNavigation(new Map([
    ['source', 'eval'], 
    ['view', 'regional'], 
    ['filter', null]
]), (new UrlHash()));
global.object = global.objects || [];
global.object.push(windowResize);
global.object.push(nav);

const trackerIds = (window.analyticsTrackerId || '').split(',');
for(let trackerId of trackerIds){
    trackerId = trackerId.trim();
    if(trackerId.length > 4){
        const tracker = new AnalyticsGoogle({trackerId});
        Analytics.addTracker(tracker);
    }
}

global.object.push(new GA());

let renderer = new HTMLRenderer();
renderer.setCanvas(document.getElementById('canvas'));
renderer.start(Main);

let backToTop = document.getElementsByClassName('back-to-top');
if(backToTop.length>0){
    global.object.push(new SimpleEvent(backToTop[0], 'click', function(event){
        event.preventDefault();
        if(window.scrollTo){
            window.scrollTo(0, 0);
        }
    }));
}